import React from 'react'
import { useAppDispatch, useAppSelector } from 'reduxTyped'

import * as builderStateActions from 'common/builder/actions/builderStateActions'
import * as buttonActions from 'common/builder/actions/buttonActions'
import { Button as ButtonComponent } from 'common/builder/components/builder/Button'
import { ButtonType } from 'common/builder/constants/ButtonType'
import builderSelectors from 'common/builder/selectors/builder'
import { getOTNButtonCaption } from 'common/builder/selectors/builder/buttonSelectors'
import * as entitySelectors from 'common/builder/selectors/builder/entitySelectors'
import * as sourceSelectors from 'common/builder/selectors/builder/sourceSelectors'
import { getCurrentAccount } from 'common/core/selectors/appSelectors'

const ButtonController = (props) => {
  const {
    target,
    buttonBlock,
    button,
    errors,
    showErrors,
    selected,
    hasTarget,
    content,
    disabled,
    hideSaveButton,
    isSimple,
    otnButtonCaption,
  } = useAppSelector((state) => {
    const { builderId, buttonId } = props
    const otnButtonCaption = getOTNButtonCaption(state, builderId, buttonId)
    let { button, errors, parentNode } = builderSelectors.button.getButtonInfo(
      state,
      builderId,
      buttonId,
    )
    const builderState = builderSelectors.builderState.getById(state, builderId)
    const content = builderSelectors.builderState.getCurrentContent(state, builderId)
    let showErrors =
      builderState.showErrors || (builderState.showErrorsFor || []).includes(buttonId)

    if (builderState.serverError && builderState.serverError.buttonId === button.id) {
      errors = [...errors, builderState.serverError]
    }

    const target = sourceSelectors.getTarget(state, builderId, buttonId)
    const hasTarget = Boolean(target)
    const disabled = !target || parentNode.flow !== builderState.flow

    const { is_buy_button_enabled } = getCurrentAccount(state)
    const hideSaveButton = !is_buy_button_enabled && button.type === ButtonType.BUY

    const buttonBlock = entitySelectors.getParentBlock(state, builderId, buttonId)

    return {
      target,
      buttonBlock,
      button,
      errors,
      showErrors,
      selected: builderState.selectedButtonId === props.buttonId,
      hasTarget,
      content,
      disabled,
      hideSaveButton,
      isSimple: Boolean(builderState.config.isSimple),
      otnButtonCaption,
    }
  })

  const dispatch = useAppDispatch()
  const handleSelect = () => {
    const { builderId, buttonId } = props
    dispatch(builderStateActions.selectButton(builderId, buttonId))
  }
  const handleDeselect = () => {
    const { builderId } = props
    dispatch(builderStateActions.selectButton(builderId, null))
  }
  const handleRemove = () => {
    const { builderId, buttonId } = props
    dispatch(buttonActions.removeButton(builderId, buttonId))
  }
  const handleOpenNode = () => {
    const { builderId, buttonId } = props
    dispatch(buttonActions.openButtonNextStep(builderId, buttonId))
  }
  const handleDrop = (node) => {
    const { builderId, buttonId } = props
    dispatch(buttonActions.selectButtonNextStep(builderId, buttonId, { nodeId: node.id }))
  }
  const handleMouseEnter = () => {
    const { builderId } = props
    if (target) {
      dispatch(builderStateActions.hover(builderId, target.id))
    }
  }
  const handleMouseLeave = () => {
    const { builderId } = props
    dispatch(builderStateActions.clearHover(builderId))
  }

  return (
    <ButtonComponent
      {...props}
      onSelect={handleSelect}
      onDeselect={handleDeselect}
      onRemove={handleRemove}
      onOpenNode={handleOpenNode}
      onDrop={handleDrop}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      buttonBlock={buttonBlock}
      button={otnButtonCaption ? { ...button, caption: otnButtonCaption } : button}
      errors={errors}
      showErrors={showErrors}
      selected={selected}
      hasTarget={hasTarget}
      content={content}
      disabled={disabled}
      hideSaveButton={hideSaveButton}
      isSimple={isSimple}
    />
  )
}

export default ButtonController
